import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import useApi from '../../utility/Hooks/Api/useApi';
import {PartsApi} from '../../services/Api/PartsApi';
import DefaultTable from '../../components/Tables/Bodies/DefaultTable';
import FunctionalTableHeader from '../../components/Tables/Headers/FunctionalTableHeader';
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import PartsEditModal from "../../components/Modals/PartsEditModal";
import ExportButton from '../../features/export/ExportButton';
import { partsExportConfig } from '../../features/export/exportConfigs/partsExportConfig';

export default function PartsView() {
    const itemEls = useRef([]);
    const {request, data} = useApi();
    const {request: deleteRequest, loading, data: deleteData, error: deleteError, reset: deleteReset} = useApi();
    const {request: editRequest, loading: editLoading, data: editData, error: editError, reset: editReset} = useApi();
    const navigate = useNavigate();
    const [checkItems, setCheckItems] = useState([]);
    const [deleteModalHidden, setDeleteModalHidden] = useState(false);
    const [editModalHidden, setEditModalHidden] = useState(false);
    const [status, setStatus] = useState("");
    const [q, setQ] = useState("");
    const [searchParam] = useState([
        "id",
        "serialNumber",
        "specification.PartType",
        "reference",
        "specification.Status",
        "orderDate",
        "location",
    ]);

    useEffect(() => {
        request(PartsApi.getParts());
        if (editData || deleteData) {
            itemEls.current = [];
            setCheckItems([...itemEls.current])
        }
    }, [deleteRequest, editRequest]);

    const column = [
        // {heading: 'ID', value: 'id',},
        {heading: 'Serial Number', value: 'serialNumber',},
        {heading: 'Type', value: 'specification.PartType',},
        {heading: 'Supplier', value: 'supplier',},
        {heading: 'Order Number', value: 'orderNumber',},
        {heading: 'Order Date', value: 'orderDate',},
        {heading: 'Shipping Date', value: 'shippingDate',},
        {heading: 'Status', value: 'reference',},
    ];

    const deletionHandler = (ele) => {
        const id = itemEls.current.find(function (element) {
            return element === ele["id"];
        });
        if (!id) {
            itemEls.current.push(ele["id"]);
            return setCheckItems([...itemEls.current])
        } else {
            const filtered = checkItems.filter(id => {
                return id !== ele["id"];
            });
            itemEls.current = [...filtered];
            return setCheckItems([...itemEls.current])
        }
    };

    const deleteRequestHandler = () => {
        checkItems.map((e) => {
            deleteRequest(PartsApi.deletePart(e))
        });
        itemEls.current = [];
        setCheckItems([...itemEls.current])
    };

    const editRequestHandler = () => {
        checkItems.map((e) => {
            const obj = data.find(function (ele) {
                return ele["id"].toString() === e.toString();
            });
            let {id, ...rest} = obj;
            editRequest(PartsApi.updatePart(obj["id"], {...rest, reference: status}))
            // editRequest(PartsApi.updatePart(obj["id"], {reference: status, location: obj["location"]}))
        });
    };

    const deleteModalHandler = () => {
        setDeleteModalHidden(!deleteModalHidden);
        if (!deleteModalHidden) {
            deleteReset();
        }
    };

    const editModalHandler = () => {
        setEditModalHidden(!editModalHidden);
        if (!editModalHidden) {
            editReset();
        }
    };

    const editOnChangeHandler = (e) => {
        setStatus(e.target.value)
    };

    const deletionCondition = checkItems.length > 0;

    useEffect(() => {

        // Bind the event listener
        let code = "";
        let reading = false;

        function handleBarcodeScanner(e) {
            if (e.keyCode === 13) {
                if (code.length > 1) {
                    const id = data.find(function (element) {
                        return element["serialNumber"]?.toString() === code.toString();
                    });
                    if (id) {
                        deletionHandler(id)
                    }
                    /// code ready to use
                    code = "";
                }
            } else {
                code += e.key; //while this is not an 'enter' it stores the every key
            }

            // run a timeout of 200ms at the first read and clear everything
            if (!reading) {
                reading = true;
                setTimeout(() => {
                    code = "";
                    reading = false;
                }, 200);  //200 works fine for me but you can adjust it
            }
        }

        document.addEventListener('keypress', handleBarcodeScanner);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("keypress", handleBarcodeScanner);
        };
    }, [data]);

    const searchHandler = (items) => {
        return items?.filter((item) => {
            return searchParam.some((newItem) => {
                if (newItem.includes(".")) {
                    const itemSplit = newItem.split(".");
                    return (
                        item[itemSplit[0]][itemSplit[1]]
                            ?.toString()
                            ?.toLowerCase()
                            ?.indexOf(q.toLowerCase()) > -1
                    );
                } else {
                    return (
                        item[newItem]
                            ?.toString()
                            ?.toLowerCase()
                            ?.indexOf(q.toLowerCase()) > -1
                    );
                }
            });
        });
    };

    const currentTableData = useMemo(() => {
        return searchHandler(data)
    }, [data, q]);

    return (
        <>
            <div className="relative container mx-auto shadow-2xl bg-white rounded-lg min-h-[46.4rem]">
                <ConfirmationModal hidden={deleteModalHidden}
                                   onCancelClick={() => deleteModalHandler(!deleteModalHidden)}
                                   loading={loading} onClick={() => deleteRequestHandler()} error={deleteError}
                                   data={deleteData}/>
                <PartsEditModal hidden={editModalHidden}
                                onCancelClick={() => editModalHandler(!editModalHidden)}
                                loading={editLoading} onClick={() => editRequestHandler()} error={editError}
                                data={editData} onChange={(e) => editOnChangeHandler(e)}/>
                <FunctionalTableHeader
                    title={"Parts"}
                    onClick={deletionCondition ? () => deleteModalHandler() : null}
                    onClickAdd={() => navigate("/main/part/add")}
                    onDelete={deletionCondition}
                    onClickEdit={() => editModalHandler()}
                    onChange={(e) => setQ(e.target.value)}
                    exportButton={<ExportButton config={partsExportConfig} data={data} companyData={null} />}/>
                <DefaultTable
                    data={currentTableData}
                    column={column} onChange={(e) => deletionHandler(e)} deletionItems={checkItems}
                    onNavDetail="/main/part/"
                    checkBox
                    pageType="parts"/>
            </div>
        </>
    );
}